export default [
	{
		handle: { crumb: () => `Interface d'expédition` },
		path: '/entertainments/:entertainmentId/deliverables/shipping/:id?',
		lazy: async () => {
			const Module = await import('@pages/shop/DeliverableShipping/DeliverableShippingPage');
			return { Component: Module.default };
		},
	},
];
